import { Skeleton } from '@material-ui/lab';
import { useState } from 'react';
import { TypographyTooltip } from 'pages/Representatives/components/TypographyTooltip';
import { formatTime } from 'shared/utils/formatTime';
import { VideoPlayButtonContainer, VideoPlayerContainer, VideoPLayerDetailsContainer } from './VideoPlayer.styles';
import PlayButtonIcon from 'shared/elements/PlayButtonIcon/PlayButtonIcon';
import ReactPlayer from 'react-player';
import { NO_IMAGE_PLACEHOLDER_URL } from 'shared/constants/ASSETS_URL';

type VideoPlayerProps = {
  url: string;
  fileName?: string;
  showDuration?: boolean;
};

const VideoPlayer = ({ url, fileName, showDuration }: VideoPlayerProps) => {
  const [duration, setDuration] = useState<number | null>(null);
  const [playing, setPlaying] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [error, setError] = useState(false);

  const handlePlay = () => {
    setPlaying((prev) => !prev);
  };

  return (
    <div style={{ position: 'relative' }}>
      <VideoPlayerContainer>
        {error ? (
          <img src={NO_IMAGE_PLACEHOLDER_URL} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <ReactPlayer
            url={url}
            playing={playing}
            onEnded={() => handlePlay()}
            onDuration={(d) => (showDuration ? setDuration(d) : null)}
            controls={playing}
            width="100%"
            height="100%"
            onReady={() => setVideoLoaded(true)}
            style={{ display: videoLoaded ? 'block' : 'none' }}
            onError={() => setError(true)}
          />
        )}

        {videoLoaded ? null : <Skeleton variant="rect" width={'100%'} height={'100%'} />}
        {!playing && !error && (
          <VideoPlayButtonContainer onClick={handlePlay}>
            <PlayButtonIcon />
          </VideoPlayButtonContainer>
        )}
      </VideoPlayerContainer>
      <VideoPLayerDetailsContainer>
        {fileName ? (
          <TypographyTooltip variant="subtitle2" style={{ flex: 1 }}>
            {fileName}
          </TypographyTooltip>
        ) : null}
        {showDuration ? (
          <TypographyTooltip
            style={{ textAlign: 'end', width: 'fit-content' }}
            variant="subtitle2"
          >{`Duration: ${duration !== null ? formatTime(duration) : '---'}`}</TypographyTooltip>
        ) : null}
      </VideoPLayerDetailsContainer>
    </div>
  );
};

export default VideoPlayer;
